import { createAction, createReducer, on, props } from '@ngrx/store';
import { TaskDTO } from '../api/plyca-dtos';
import * as lodash from 'lodash';

export const SET_PENDINGTASKS = createAction('SET_PENDINGTASKS', props<{ tasks: TaskDTO[] }>());
export const DELETE_PENDINGTASKS = createAction('DELETE_PENDINGTASKS');
export const SET_DOSSIER_PENDINGTASKS = createAction('SET_DOSSIER_PENDINGTASKS', props<{ tasks: TaskDTO[], dossierId: string }>());
export const UPDATE_PENDINGTASK = createAction('UPDATE_PENDINGTASK', props<{ task: TaskDTO }>());
export const DELETE_PENDINGTASK = createAction('DELETE_PENDINGTASK', props<{ identifier: string }>());

const initialState = [];

const _pendingTasksReducer = createReducer(
  initialState,
  on(SET_PENDINGTASKS, (state, { tasks }) => tasks),
  on(DELETE_PENDINGTASKS, () => initialState),
  on(SET_DOSSIER_PENDINGTASKS, (state, { tasks, dossierId }) => {
    let result = state.filter(item => item.division.project.identifier !== dossierId);
    if (tasks != null) {
      result = result.concat(tasks);
    }
    return result;
  }),
  on(UPDATE_PENDINGTASK, (state, { task }) => state.map(item => {

    // Actualizamos los datos de estado de bloqueo de la tarea
    // No queremos sustituirla por la consultada porque puede tener datos diferentes
    // a los que se dispone en el gestor de tareas

    if (item.identifier === task.identifier) {

      let arrayKeysExcept = ['status', 'lockedBy', 'availableActions'];
      let temp = lodash.cloneDeep(task);
      Object.keys(temp).forEach(
        function (key) {
          if (arrayKeysExcept.indexOf(key) === -1) {
            delete temp[key];
          }
        });

      return Object.assign({}, item, temp);

    } else {
      return item;
    }

  })),
  on(DELETE_PENDINGTASK, (state, { identifier }) => state.filter(item => {
    return item.identifier !== identifier;
  }))
);

export function pendingTasksReducer(state, action) {
  return _pendingTasksReducer(state, action);
}
